
export default {
  name: 'VolleyballIcon',
  props: {
    classCss: { type: String, default: '' },
  },
}
